/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Region, RegionFromJSON, RegionToJSON } from './'

/**
 *
 * @export
 * @interface Regions
 */
export interface Regions {
  /**
   * Regions requester can see.
   * @type {Array<Region>}
   * @memberof Regions
   */
  regions: Array<Region>
}

export function RegionsFromJSON(json: any): Regions {
  return RegionsFromJSONTyped(json, false)
}

export function RegionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Regions {
  if (json === undefined || json === null) {
    return json
  }
  return {
    regions: (json['regions'] as Array<any>).map(RegionFromJSON),
  }
}

export function RegionsToJSON(value?: Regions | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    regions: (value.regions as Array<any>).map(RegionToJSON),
  }
}
